'use client'

/**
 * Background telemetry only. The visible recovery toast was retired:
 *
 *  1. `error.tsx` (root) and `global-error.tsx` already show a proper
 *     recovery UI on render-time crashes.
 *  2. The pre-hydration script in `layout.tsx` auto-reloads on
 *     stale-chunk errors (the most common page-breaking class).
 *  3. PostHog `capture_exceptions` records JS errors for diagnosis.
 *
 * Window-level `error` / `unhandledrejection` events are dominated by
 * benign noise (PowerSync probes, AbortError on cancelled fetches,
 * connectivity checks, third-party script loaders). Surfacing a sticky
 * "Seite kann momentan nicht angezeigt werden" toast for those is
 * actively misleading — the page is fine.
 *
 * Component is kept (and still mounted) as a no-op so removing the
 * import path everywhere isn't necessary; deletion can come later.
 */
export function GlobalErrorCatcher() {
  return null
}
